// Module
var code = `<section class="page-body default-content">






  <h2>Checkboxes</h2>
  <p>
    Checkboxes allow users to select one or more options from a group.
    SpyneJS styles checkboxes with larger, centered checkmarks, token-driven colors,
    and accessible hint text for validation states.
  </p>

  <!-- Default -->
  <h3>Default Checkbox</h3>
  <div class="form-examples">
    <label class="checkbox" for="check-default">
      <input id="check-default" type="checkbox" />
      Default Checkbox
    </label>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="checkbox" for="check-default"&gt;
  &lt;input id="check-default" type="checkbox" /&gt;
  Default Checkbox
&lt;/label&gt;
    </code></pre>
  </div>

  <!-- Checked -->
  <h3>Checked State</h3>
  <div class="form-examples">
    <label class="checkbox" for="check-checked">
      <input id="check-checked" type="checkbox" checked />
      Checked Option
    </label>
  </div>

  <!-- Disabled -->
  <h3>Disabled Checkbox</h3>
  <div class="form-examples">
    <label class="checkbox" for="check-disabled">
      <input id="check-disabled" type="checkbox" disabled />
      Disabled Option
    </label>
  </div>

  <!-- Validation -->
  <h3>Validation States</h3>
  <p>
    Apply <code>.success</code> or <code>.error</code> classes directly to checkboxes for validation feedback.
    Include hint text for better accessibility.
  </p>
  <div class="form-examples">
    <div>
      <label class="checkbox" for="check-success">
        <input id="check-success" type="checkbox" class="success" checked />
        Success Checkbox
      </label>
      <div class="input-hint success">✓ Looks good</div>
    </div>
    <div>
      <label class="checkbox" for="check-error">
        <input id="check-error" type="checkbox" class="error" checked />
        Error Checkbox
      </label>
      <div class="input-error-label">✕ Please fix this selection</div>
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="checkbox" for="check-success"&gt;
  &lt;input id="check-success" type="checkbox" class="success" checked /&gt;
  Success Checkbox
&lt;/label&gt;
&lt;div class="input-hint success"&gt;✓ Looks good&lt;/div&gt;

&lt;label class="checkbox" for="check-error"&gt;
  &lt;input id="check-error" type="checkbox" class="error" checked /&gt;
  Error Checkbox
&lt;/label&gt;
&lt;div class="input-error-label"&gt;✕ Please fix this selection&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always wrap checkboxes in a <code>&lt;label&gt;</code> for larger click targets.</li>
    <li>Use hint text with icons (✓, ✕) so validation is not communicated by color alone.</li>
    <li>Provide unique <code>id</code> values and link them with <code>for</code> attributes.</li>
    <li>Ensure disabled checkboxes remain distinguishable from active ones.</li>
  </ul>

  <!-- Back link -->
  <p>
    <a class="route-link" data-channel="ROUTE"
       data-page-id="elements" data-topic-id="forms" data-option-id=""
       href="/elements/forms">← Back to Forms Overview</a>
  </p>

</section>
`;
// Exports
module.exports = code;